import { Component } from '@angular/core';
import { Platform, AlertController, NavController } from '@ionic/angular';
import { LoadingService } from './services/loading.service';
import { ApiService } from './services/api.service';
import { HttpClient } from '@angular/common/http';

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss'],
})
export class AppComponent {
	user_latitude: number;
	user_longitude: number;
	plant_latitude: number;
	plant_longitude: number;
	plant_Radius: number;
	status: any


	constructor(
		public api: ApiService,
		public loading: LoadingService,
		private platform: Platform,
		private alertCtrl: AlertController,
		private http: HttpClient,
		private navCtrl: NavController,

	) {
		this.initializeApp();

	}

	initializeApp() {
		this.platform.ready().then(() => {
			if (this.platform.is('ios') == false) {
				this.showExitConfirm()
			}
		});
	}

	showExitConfirm() {
		this.alertCtrl.create({
			header: 'Alert',
			message: 'This APP is compatible with iOS only.',
			backdropDismiss: false,
			buttons: [
				{
					text: 'Ok',
					handler: () => {
						if (this.platform.is('ios') == false) {
							this.showExitConfirm()
				
						}
					}
				}]
		}).then(alert => {
			alert.present();
		});
	}
}